import { defineStore } from 'pinia'

import { StoreId } from '@/store'
import { ToggleState } from '@/store/toggle/toggle.types'

import { Success } from '@/api/results'

export const useToggleStore = defineStore({
  id: StoreId.TOGGLE,
  state: (): ToggleState => ({
    featureToggle: {
      basket_enabled: false,
      new_catalog_enabled: false,
      carrotquest_enabled: false,
      carrotquest_mobile_chat_enabled: false,
      carrotquest_site_chat_enabled: false,
      halves_enabled: false,
      auth_by_vk_id_enabled: false,
      basket_order_checkout_do_not_call_me_back_enabled: false,
      stories_enabled: false,
      address_v4_enabled: false,
      product_card_enabled: false,
      outsource_game_enabled: true,
      new_address_flow_enabled: false,
    },
    isLoaded: false,
  }),
  actions: {
    async getFeatureToggles() {
      if (this.isLoaded) {
        return
      }

      const { $apiService } = useNuxtApp()

      const result = await $apiService.city.fetchFeatureToggle()

      this.isLoaded = true

      if (result instanceof Success) {
        this.featureToggle = Object.assign(this.featureToggle, result.data)
      }
    },
  },
  getters: {
    isVisibleStories: ({ featureToggle }) => featureToggle.stories_enabled,
    // Включены ли новая главная страница и каталог
    newCatalogEnabled: ({ featureToggle }) =>
      featureToggle?.new_catalog_enabled,
    basketEnabled: ({ featureToggle }) => featureToggle.basket_enabled,
    newAddressFlowEnabled: ({ featureToggle }) =>
      featureToggle.new_address_flow_enabled,
  },
})
